/** KST(한국 시간) 기준 날짜 포맷 */
const KST_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZone: 'Asia/Seoul',
};

/** 브라우저 로컬 시간대 기준 날짜 포맷 */
const LOCAL_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
};

function parse(dateStr: string | null | undefined): Date | null {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date;
}

/** 날짜 문자열을 KST(한국 시간) 기준으로 표시하는 함수
 * @description KST 기준 "YYYY년 MM월 DD일 오전/오후 hh:mm" 형식으로 표시
 * @param dateStr - 날짜 문자열
 * @param options - 날짜 포맷 옵션 (실제 함수 호출시에 넘기는 옵션 아님)
 * @returns 날짜 문자열 (KST 기준, YYYY년 MM월 DD일 오전/오후 hh:mm)
 * @returns '-' 날짜 문자열이 없을 경우
 */
export function formatDate(
  dateStr: string | null | undefined,
  options: Intl.DateTimeFormatOptions = KST_OPTIONS,
): string {
  const date = parse(dateStr);
  if (!date) return '-';
  return date.toLocaleString('ko-KR', options);
}

/** 날짜 문자열을 KST 기준 날짜만 표시하는 함수
 * @description KST 기준 "YYYY년 MM월 DD일" 형식으로 표시
 * @param dateStr - 날짜 문자열
 * @returns 날짜 문자열 (브라우저 로컬 시간대 기준, YYYY년 MM월 DD일)
 * @returns '-' 날짜 문자열이 없을 경우
 */
export function formatDateOnly(dateStr: string | null | undefined): string {
  return formatDate(dateStr, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Asia/Seoul',
  });
}

/** 날짜 문자열을 브라우저 로컬 시간대 기준으로 표시하는 함수
 * @description 브라우저 로컬 시간대 기준 "YYYY년 MM월 DD일 오전/오후 hh:mm" 형식으로 표시
 * @param dateStr - 날짜 문자열
 * @returns 날짜 문자열 (브라우저 로컬 시간대 기준, YYYY년 MM월 DD일 오전/오후 hh:mm)
 * @returns '-' 날짜 문자열이 없을 경우
 * @example
 * formatDateLocal('2021-01-01T00:00:00Z')
 * => 한국 사용자 (UTC+9) : '2021년 1월 1일 오전 9:00'
 * => 뉴욕 사용자 (UTC-5) : '2020년 12월 31일 오후 7:00'
 */
export function formatDateLocal(dateStr: string | null | undefined): string {
  const date = parse(dateStr);
  if (!date) return '-';
  return date.toLocaleString('ko-KR', LOCAL_OPTIONS);
}
